import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import App from './App';
import 'assets/styles/index.scss';
import PlatformProvider from 'hooks/PlatformContext';
import { LanguageProvider } from 'hooks/Languages/useLanguage';

// Suppress benign third-party browser extension errors (e.g., MetaMask inpage.js) from triggering dev overlay
if (typeof window !== 'undefined') {
  const isExtensionError = (msg?: string, src?: string) => {
    const combined = `${msg || ''} ${src || ''}`;
    return (
      combined.includes('chrome-extension://') ||
      combined.includes('moz-extension://') ||
      combined.includes('nkbihfbeogaeaoehlefnkodbefgpgknn') ||
      combined.includes('MetaMask') ||
      combined.includes('inpage.js')
    );
  };

  window.addEventListener(
    'error',
    (event) => {
      const msg = event.message || event.error?.message;
      const src = event.filename || event.error?.stack;
      if (isExtensionError(msg, src)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );

  window.addEventListener(
    'unhandledrejection',
    (event) => {
      const reasonStr = String(event.reason?.message || event.reason?.stack || event.reason || '');
      if (isExtensionError(reasonStr)) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <PlatformProvider>
      <LanguageProvider>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </LanguageProvider>
    </PlatformProvider>
  </QueryClientProvider>
);
